if (document.querySelector(".mt-logo-list__container") != null) {
  // 存储所有轮播实例
  const carouselInstances = new Map();
  
  // 初始化轮播的函数
  function initCarousel(container) {
    const containerId = container.dataset.containerId || Math.random().toString(36).substr(2, 9);
    container.dataset.containerId = containerId;
    
    // 检查当前设备类型
    const isMobile = window.innerWidth < 750;
    
    // 如果已经有实例，先销毁
    if (carouselInstances.has(containerId)) {
      const existingInstance = carouselInstances.get(containerId);
      if (existingInstance.flkty) {
        existingInstance.flkty.destroy();
      }
      if (existingInstance.animationId) {
        cancelAnimationFrame(existingInstance.animationId);
      }
      carouselInstances.delete(containerId);
    }
    
    // 移动端始终轮播，PC端根据设置决定
    if (isMobile) {
      // 移动端无条件启用轮播
    } else {
      // PC端检查是否启用轮播
      const enableCarousel = container.getAttribute('data-enable-carousel') === 'true';
      if (!enableCarousel) {
        // PC端不启用轮播时，直接返回，不初始化任何轮播功能
        return;
      }
    }
    
    // 初始化Flickity（禁用大部分默认行为）
    const flkty = new Flickity(container.querySelector('.mt-logo-list__items'), {
      wrapAround: true,
      autoPlay: false,    // 禁用自动播放
      pageDots: false,
      prevNextButtons: false,
      draggable: false,  // 禁用拖动
      freeScroll: false,
      cellAlign: 'left'
    });

    // 获取滑动容器
    const viewport = container.querySelector('.flickity-viewport');
    
    // 匀速滚动参数
    const pixelsPerFrame = 1; // 每帧移动的像素数
    const fps = 60;           // 帧率
    let lastTime = 0;
    let animationId;
    
    // 动画循环
    function animate(currentTime) {
      if (!lastTime) lastTime = currentTime;
      const deltaTime = currentTime - lastTime;
      lastTime = currentTime;
      
      // 计算应该移动的距离
      const scrollAmount = pixelsPerFrame * (deltaTime / (1000 / fps));
      
      // 更新位置
      flkty.x = (flkty.x - scrollAmount) % flkty.slideableWidth;
      flkty.selectedIndex = flkty.dragEndRestingSelect();
      flkty.settle(flkty.x);
      viewport.scrollLeft = -flkty.x;
      
      // 继续动画
      animationId = requestAnimationFrame(animate);
    }
    
    // 启动动画
    animationId = requestAnimationFrame(animate);
    
    // 存储实例
    carouselInstances.set(containerId, { flkty, animationId });
  }
  
  // 初始化所有轮播
  document.querySelectorAll(".mt-logo-list__container").forEach((container) => {
    initCarousel(container);
  });
  
  // 监听窗口大小变化，重新初始化轮播
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      document.querySelectorAll(".mt-logo-list__container").forEach((container) => {
        initCarousel(container);
      });
    }, 100);
  });
}
